var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2578 7.47743L20.0003 11.7399V3.03491L13.2578 7.47743Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.03491V11.7399L6.74253 7.47743L0 3.03491Z",
    fill: "#7A7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7497 0.5H1.24961C0.625862 0.5 0.13086 0.965002 0.0371094 1.56375L9.99965 8.12753L19.9622 1.56375C19.8684 0.965002 19.3734 0.5 18.7497 0.5Z",
    fill: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1136 8.23245L10.3448 9.39746C10.2398 9.46621 10.1211 9.49996 10.0011 9.49996C9.88106 9.49996 9.76231 9.46621 9.65731 9.39746L7.88855 8.2312L0.0410156 13.195C0.137266 13.7887 0.629768 14.25 1.25102 14.25H18.7511C19.3724 14.25 19.8649 13.7887 19.9611 13.195L12.1136 8.23245Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/iconEmail.f7ae31f79862e6f979c81c9dad56b06b.svg";
export { ForwardRef as ReactComponent };